import { useSearchByKeyword } from "@/hooks/useSearchByKeyword";
import { chatsApi } from "@/lib/humhub-api/chats";
import type { ChatRoomType } from "@/lib/humhub-api/types";

/**
 * Hook for searching chat rooms by keyword
 * @param initialKeyword - Initial search keyword
 */
export const useSearchChatRooms = (
  initialKeyword?: string,
  initialType?: ChatRoomType,
) => {
  const searchState = useSearchByKeyword({
    keyBase: "searchChatRooms",
    initialKeyword,
    initialType,
    fetcher: chatsApi.searchChatRooms,
    staleTimeMs: 3 * 60 * 1000,
  });

  return {
    isLoading: searchState.isLoading,
    error: searchState.error,
    searchChatRooms: searchState.search,
    response: searchState.response,
    refetchSearch: searchState.refetchSearch,
    prefetchSearch: searchState.prefetchSearch,
    clearSearch: searchState.clearSearch,
    currentKeyword: searchState.currentKeyword,
  };
};
